import UserAgent from '../UserAgent/UserAgent'

import isRestrictedByRestriction from './utils/isRestrictedByRestriction'

import type { TRestrictions } from './definitions'
import getSystemInfo from './utils/getSystemInfo'

export default class RestrictionHandler {
  /**
   * Korlátozva van?
   * @param restrictions - Korlátozások.
   */
  public isRestricted (restrictions: TRestrictions): boolean {
    const userAgent = UserAgent.getInstance()

    return restrictions.some((restriction) => {
      const info = getSystemInfo(userAgent)

      return isRestrictedByRestriction(restriction, info)
    })
  }
}
